var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-bar",class:{ 'ui-bar--is-tall': _vm.isTall }},[_c('div',{staticClass:"ui-bar__elements-list"},[_vm._t("default")],2),_vm._t("progress-bar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }